
<app-azure-step1 *ngIf="shareDataService.step === 1"></app-azure-step1>
<app-azure-step2 *ngIf="shareDataService.step === 2"></app-azure-step2>
<app-azure-step3 *ngIf="shareDataService.step === 3"></app-azure-step3>
